(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["timeline-horizontal"] && !Shopify.designMode) return;
  try {
    
(function loadGSAP(callback) {
  // If GSAP + ScrollTrigger already loaded, skip loading
  if (window.gsap && window.ScrollTrigger) {
    callback();
    return;
  }

  // Helper to load external scripts
  function inject(src, onload) {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = onload;
    document.head.appendChild(s);
  }

  // Load GSAP first
  inject("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js", () => {
    // Then load ScrollTrigger
    inject("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js", callback);
  });

})(function initTimeline() {

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll("[data-timeline]").forEach(section => {
    const viewport = section.querySelector('.timeline__viewport');
    const track = section.querySelector('.timeline__track');

    function scrollAmount(){
      return track.scrollWidth - viewport.clientWidth;
    }

    gsap.to(track, {
      x: () => -scrollAmount(),
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: "top-=50 top",
        end: () => "+=" + scrollAmount(),
        scrub: true,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true
      }
    });

    window.addEventListener('resize', () => ScrollTrigger.refresh());
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-scrolling-content"] && !Shopify.designMode) return;
  try {
    
// Vertical Scrolling Content Ticker
function initScroller() {
  document.querySelectorAll('.vsc-track').forEach(track => {
    const viewport = track.closest('.ticker__viewport');
    if (!viewport) return;

    // Duplicate only once
    if (!track.dataset.duplicated) {
      track.innerHTML += track.innerHTML;
      track.dataset.duplicated = "true";
    }

    // Get row height from rendered elements
    const rowHeight = track.children[0].getBoundingClientRect().height;
    const totalItems = track.children.length / 2;
    const loopHeight = totalItems * rowHeight;

    // Speed from CSS var (px/sec)
    const speed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vsc-speed')) || 40;
    const duration = loopHeight / speed;

    // Create unique animation
    const animName = `vscroll_${Math.random().toString(36).slice(2)}`;
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      @keyframes ${animName} {
        from { transform: translateY(0); }
        to   { transform: translateY(-${loopHeight}px); }
      }
    `;
    document.head.appendChild(styleEl);

    // Apply animation
    track.style.animation = `${animName} ${duration}s linear infinite normal`;

    // Pause on hover (desktop + accessibility)
    /*viewport.addEventListener('mouseenter', () => track.style.animationPlayState = 'paused');
    viewport.addEventListener('mouseleave', () => track.style.animationPlayState = 'running');
    viewport.addEventListener('focusin', () => track.style.animationPlayState = 'paused');
    viewport.addEventListener('focusout', () => track.style.animationPlayState = 'running');*/
  });
}

// Init when DOM is ready
document.addEventListener("DOMContentLoaded", initScroller);

// Recalculate on resize / orientation change
let tickerResize;
window.addEventListener("resize", () => {
  clearTimeout(tickerResize);

  // Reset animations to force recalculation
  document.querySelectorAll('.vsc-track').forEach(track => {
    track.style.animation = 'none';
  });

  tickerResize = setTimeout(initScroller, 120);
});

  } catch(e) { console.error(e); }
})();
})();
